import React from 'react'

import PropTypes from 'prop-types'
import BoardList from './BoardList'
import Button from './Button'

const SignOutButton = (props) => (
  <Button
    {...props}
    name="sidePanelSignOutButton"
    text={`Sign Out ${props.email}`}
  />
)

const Spacer = () => <div className="sidePanelSpacer" />

const SidePanel = ({ user, onClickSignOut }) => (
  <div className="sidePanel">
    <div className="sidePanelContent">
      <BoardList />
      <Spacer />
      <SignOutButton email={user?.email} onClick={onClickSignOut} />
    </div>
  </div>
)

SignOutButton.propTypes = {
  email: PropTypes.string,
}

SidePanel.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string,
  }),
  onClickSignOut: PropTypes.func,
}

export default SidePanel
